import { isDateValid, getFormattedDate } from '../../../../../utils/acquisition-utils';
import { ageVerification } from './util/ageVerification';
import getErrorMessage from './util/getErrorMessage';
import getFormattedDay from './util/getFormattedDay';
import getFormattedMonth from './util/getFormattedMonth';
import getLastDayOfTheMonth from './util/getLastDayOfTheMonth';
import isDayValueValid from './util/isDayValueValid';
import setInitialValue from './util/setInitialValue';
import visitedResolver from './util/visitedResolver';
interface IDateComponent {
	error: boolean;
	value: string;
	visited: boolean;
	focused: boolean;
	valid: boolean;
	valueAddAttempted: boolean;
}

interface IDateOptions {
	isRelated: boolean;
}

type TTarget = 'day' | 'month' | 'year';

export interface IDateData {
	day: IDateComponent;
	month: IDateComponent;
	year: IDateComponent;
	invalidErrorMessage: string;
	position: TTarget | '';
}

export const defaultData: () => IDateData = () => ({
	day: {
		error: false,
		value: '',
		visited: false,
		focused: false,
		valid: false,
		valueAddAttempted: false,
	},
	month: {
		error: false,
		value: '',
		visited: false,
		focused: false,
		valid: false,
		valueAddAttempted: false,
	},
	year: {
		error: false,
		value: '',
		visited: false,
		focused: false,
		valid: false,
		valueAddAttempted: false,
	},
	invalidErrorMessage: '',
	position: '',
});

interface IOnBlurCase {
	type: 'onBlur';
	target: TTarget;
	options?: IDateOptions;
}

interface IOnFocusCase {
	type: 'onFocus';
	target: TTarget;
}

export interface ISetValueCase {
	type: 'setValue';
	target: 'day' | 'month' | 'year';
	payload: string;
	year: number;
	minAge: number;
	maxAge: number;
}

interface IInitializeCase {
	type: 'initialize';
	payload: string;
}

interface IClearCase {
	type: 'clear';
	payload: {
		error: boolean;
	};
}

interface IValueAddAttempted {
	type: 'valueAddAttempted';
	target: TTarget;
}

export type TDateDataAction =
	| IOnBlurCase
	| IOnFocusCase
	| ISetValueCase
	| IInitializeCase
	| IClearCase
	| IValueAddAttempted;

export default function inputDateReducer(
	state: IDateData,
	action: TDateDataAction,
) {
	const lastDayOfTheMonth = getLastDayOfTheMonth({
		month: state.month.value,
		year: state.year.value,
	});
	switch (action.type) {
		case 'onBlur':
			state[action.target].focused = false;
			state[action.target].visited = true;
			state.position = '';

			if (state.day.value.length === 1) {
				if (state.day.value === '0') {
					state.day.value = '';
				} else {
					state.day.value = '0' + state.day.value;
				}
			}

			if (state.month.value.length === 1) {
				if (state.month.value === '0') {
					state.month.value = '';
				} else {
					state.month.value = '0' + state.month.value;
				}
			}

			if (state.year.value.length !== 4) {
				state.year.value = '';
			}

			if (
				state.day.value &&
				parseInt(state.day.value) > lastDayOfTheMonth
			) {
				state.day.value = '';
			}

			visitedResolver(state, lastDayOfTheMonth);

			if (!action.options?.isRelated) {
				if (!state.month.visited) {
					state.month.error = true
				}
				if (!state.day.visited) {
					state.day.error = true
				}
				if (!state.year.visited) {
					state.year.error = true
				}
			}

			break;
		case 'onFocus':
			state[action.target].focused = true;

			break;
		case 'setValue':
			if (action.target === 'day') {
				state.day.value = getFormattedDay(
					action.payload,
					lastDayOfTheMonth,
				);
				if (isDayValueValid(state.day.value, lastDayOfTheMonth)) {
					if (state.month.value && state.year.value) {
						if (ageVerification(state, action)) {
							state.day.valid = true;
							state.day.error = false;
							state.invalidErrorMessage = '';
							state.position = 'year';
						} else if (
							state.day.valueAddAttempted &&
							state.month.valueAddAttempted &&
							state.year.valueAddAttempted
						){
							state.day.valid = false;
								state.day.error = true;
								state.invalidErrorMessage = getErrorMessage(
									state.month.error,
									state.day.error,
									state.year.error,
								);
						 }
					} else if (state.month.value) {
						state.position = 'year';
					}
				}
			}
			if (action.target === 'month') {
				state.month.value = getFormattedMonth(action.payload);
				if (state.month.value.length === 2) {
					if (state.day.value && state.year.value) {
						if (ageVerification(state, action)) {
							state.month.valid = true;
							state.month.error = false;
							state.invalidErrorMessage = '';
							state.position = 'day';
						} else if (
							state.day.valueAddAttempted &&
							state.month.valueAddAttempted &&
							state.year.valueAddAttempted){
							state.month.valid = false;
								state.month.error = true;
								state.invalidErrorMessage = getErrorMessage(
									state.month.error,
									state.day.error,
									state.year.error,
								);
						}
					} else if (state.month.value) {
						state.position = 'day';
					}
				}
			}
			if (action.target === 'year') {
				if (action.payload.length < 4) {
					state.year.value = action.payload;
				}
				if (action.payload.length >= 4) {
					state.year.value = action.payload.slice(0, 4);

					if (ageVerification(state, action)) {
						state.year.valid = true;
						state.year.error = false;
						state.invalidErrorMessage = '';
					} else if (
						state.day.valueAddAttempted &&
						state.month.valueAddAttempted &&
						state.year.valueAddAttempted){
							state.year.valid = false;
							state.year.error = true;
							state.invalidErrorMessage = getErrorMessage(
								state.month.error,
								state.day.error,
								state.year.error,
							);
					}
				}
			}
			break;
		case 'initialize':
			setInitialValue(state, action.payload);
			break;
		case 'clear':
			state = {
				day: {
					error: false,
					value: state.day.value,
					visited: false,
					focused: false,
					valid: false,
					valueAddAttempted: false,
				},
				month: {
					error: false,
					value: state.month.value,
					visited: false,
					focused: false,
					valid: false,
					valueAddAttempted: false,
				},
				year: {
					error: false,
					value: state.year.value,
					visited: false,
					focused: false,
					valid: false,
					valueAddAttempted: false,
				},
				invalidErrorMessage: '',
				position: '',
			};
			if (action.payload.error) {
				state.day.error = true;
				state.day.valid = false;
				state.month.error = true;
				state.month.valid = false;
				state.year.error = true;
				state.year.valid = false;
				state.invalidErrorMessage = getErrorMessage(
					state.month.error,
					state.day.error,
					state.year.error,
				);
			}
			break;
		case 'valueAddAttempted':
			state[action.target].valueAddAttempted = true;
			break;
	}
	return JSON.parse(JSON.stringify(state));
}
